import { memo, type ReactNode } from "react";
import { useForecastingPoFlag } from "./forecasting-po-flag-provider";

export const ForecastingPoFlagGate = memo(function ForecastingPoFlagGate({
  children,
}: {
  children: ReactNode;
}) {
  const { enabled } = useForecastingPoFlag();

  if (!enabled) {
    return null;
  }

  return <>{children}</>;
});
